// Components, Layouts, Pages
import { AuthLayout } from '~/layouts';
import {
  SignInCommonPage,
  VerifyCodePage,
  SuccessfullyPage,
  ForgotPasswordCommonPage,
  CreateNewPasswordCommonPage,
} from '~/pages/common';
// Others
import { IRouteModel } from '~/utils/interface/base';

export const authRoute = {
  base: '/auth',
  login: '/login',
  forgotPassword: '/forgot-password',
  verifyCode: '/verify-code',
  createNewPassword: '/create-new-password',
  successfully: '/successfully',
};

export const authRoutes: IRouteModel[] = [
  {
    path: `${authRoute.base}`,
    component: AuthLayout,
    children: [
      {
        index: true,
        path: '',
        component: SignInCommonPage,
      },
      {
        path: `${authRoute.base}${authRoute.forgotPassword}`,
        component: ForgotPasswordCommonPage,
      },
      {
        path: `${authRoute.base}${authRoute.verifyCode}`,
        component: VerifyCodePage,
      },
      {
        path: `${authRoute.base}${authRoute.createNewPassword}`,
        component: CreateNewPasswordCommonPage,
      },
      {
        path: `${authRoute.base}${authRoute.successfully}`,
        component: SuccessfullyPage,
      },
    ],
  },
];

export const authRouteAbsolute = {
  login: `${authRoute.base}`,
  forgotPassword: `${authRoute.base}${authRoute.forgotPassword}`,
  verifyCode: `${authRoute.base}${authRoute.verifyCode}`,
  createNewPassword: `${authRoute.base}${authRoute.createNewPassword}`,
  successfully: `${authRoute.base}${authRoute.successfully}`,
};
